import React, { useContext, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import { db } from '../../Firebase/firebase'

import moment from 'moment'

import './Comment.css'

const Comment = ({props, commentID}) => {
  const {postID} = useParams()

  const { userName, comment, createdAt } = props
  const { isLight } = useContext(ThemeContext)
  const { currentUser } = useContext(AuthContext)

// /

  const [editing, isEditing] = useState(false)
  const [editingText, setEditingText] = useState(comment)

  const updateComment = () => {
    db.collection('posts').doc(postID).collection('comments').doc(commentID).update(
      {
        comment: editingText
      }
    )
      .then(() => isEditing(false))
      .catch(err => alert(err.message))
  }

  const deleteComment = () => {
    db.collection('posts').doc(postID).collection('comments').doc(commentID).delete()
      .then(() => isEditing(false))
      .catch(err => alert(err.message))
  }

  const toggleEdit = () => {
    isEditing(!editing)
    console.log(editing)
  }

  return (
    <section className={`comment ${isLight ? "" : "dark"}`}>
      <div className="comment__col">
        <div className="comment__post__details">
          <Link to={`/user/${userName}`}>
            <p className="comment__userName">{userName}</p>
          </Link>
          {createdAt ? (              //*CreatedAt was coming null and then being updated so to prevent it we check if createdAt exists if it dosent we return nothing or else we return the date using moment
            <h2 className="comment__platform__date">{moment(createdAt.toDate()).format("[•] MMM Do YYYY [at] h:mm a")}</h2>
          ) : ""}
        </div>
        
        {
          editing ? (
            <div className="comment__form">
              <textarea type="text" className="comment__input" required value={editingText} onChange={e => setEditingText(e.target.value)}/>
              <div className="comment__editing__col">
                <button className="comment__edit-btn update" onClick={updateComment}>Change</button>
                <button className="comment__edit-btn cancel" onClick={() => isEditing(false)}>Cancel</button>
                <button className="comment__edit-btn delete" onClick={deleteComment}>Delete</button>
              </div>
            </div>
          ) : (
            <>
              <p className="comment__detail">{comment}</p>
            </>
          )
        }
      </div>
      { currentUser ? (
        currentUser.displayName === userName ? (
          editing ?  ( "" ) : ( <button className="comment__btn" onClick={toggleEdit}>Edit</button> )
        ) : ("")
        ) : ""
      }
    </section>
  )
}

export default Comment
